import { USER_HAS_SEEN_THE_OPENAI_TERMS } from './constants';
import type { EditorState } from '@/stateManagement';

const getIsAiTermsAndConditionsShown = (state: EditorState): boolean =>
  Boolean(state.userPreferences.session?.[USER_HAS_SEEN_THE_OPENAI_TERMS]);

export { getIsAiTermsAndConditionsShown };
